import React, { FC } from 'react';
import { AnimatedLink } from '../../../../doctrine/components/animated-link/AnimatedLink';
import styles from './public_text_block.module.scss';

type Props = {
  type?: string;
  title: string;
  text: string;
  link?: string;
  linkText?: string;
  titleTag: 'h3' | 'h5';
};

export const PublicTextBlock: FC<Props> = ({
  type,
  title,
  text,
  link,
  linkText,
  titleTag: TitleTag,
}) => (
  <div className={styles.textContainer}>
    {type && <div className={styles.smallCaps}>{type}</div>}
    <TitleTag className={styles.title}>{title}</TitleTag>
    {/* eslint-disable-next-line react/no-danger */}
    <p className={styles.text} dangerouslySetInnerHTML={{ __html: text }} />
    {link && linkText && (
      <div className={styles.link}>
        <AnimatedLink href={link}>{linkText}</AnimatedLink>
      </div>
    )}
  </div>
);
